<template>
    <div v-if="associatedSites.length > 0">
        <h3 v-if="loggedInContact">Hospitals where I work:</h3>
        <h3 v-if="!loggedInContact">Works at these hospital sites:</h3>
        <ul>
            <li class="tooltip-site" v-for="s in associatedSites" :key="s.id" :class="{current: selectedHospital == s.id}">{{s.siteName}}</li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "ContactSites",

        props: ["contactSites", "loggedInContact"],

        data() {
            return {
                selectedHospital: null
            };
        },

        watch: {
            $route(to) {
                this.selectedHospital = to.params.hospital;
            }
        },

        created() {
            this.selectedHospital = this.$route.params.hospital;
        },

        computed: {
            associatedSites: function() {
                var temp = this.contactSites;
                return temp.filter(function(u) {
                    return u.associated;
                });
            }
        }
    };
</script>